import { render, staticRenderFns } from "./modal_file.vue?vue&type=template&id=6d2fbc15&scoped=true"
import script from "./modal_file.vue?vue&type=script&lang=js"
export * from "./modal_file.vue?vue&type=script&lang=js"
import style0 from "./modal_file.vue?vue&type=style&index=0&id=6d2fbc15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2fbc15",
  null
  
)

export default component.exports